import CustomToast from "components/atoms/CustomToast";
import Button from "components/common/buttons/buttons";
import { TYPO } from "styles/Typo";
import { useState } from "react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { routeToLoginPage } from "utils/routing";
import { useMutation } from "@tanstack/react-query";
import { postFetcher } from "utils/clientAPIs/fetcher";
import useIsDetailLoading from "states/detailLoading";

function RequestDataTemp({
  isDisplay,
  subTitle,
  title,
  buttonText,
  dataGtmId,
  clickHandler,
  ticker,
  url,
  successHandler,
  failHandler,
}: {
  isDisplay: boolean;
  subTitle: string;
  title: string;
  buttonText: string;
  dataGtmId?: string;
  clickHandler?: () => void;
  ticker: string;
  url: string;
  successHandler?: () => void;
  failHandler?: (reason?: string) => void;
}) {
  const isLoading = useIsDetailLoading();
  const [toastStatus, setToastStatus] = useState<string | null>(null);
  const [isRequesting, setIsRequesting] = useState(false);
  const { data: session } = useSession();
  const router = useRouter();
  const mutation = useMutation({
    mutationFn: async () => {
      setIsRequesting(true);
      await postFetcher(url, {
        ticker,
        email: session?.user?.email,
      });
      return true;
    },
    onSuccess: () => {
      console.log("onSuccess");
      setToastStatus("success");
      setIsRequesting(false);
      successHandler && successHandler();
    },
    onError: (error: any) => {
      const errorCode = error.response.data.code;
      setToastStatus("error");
      setIsRequesting(false);
      failHandler && failHandler("backend_" + errorCode.toString());
    },
  });

  const requestData = () => {
    const isLoggedIn = routeToLoginPage(router, session);
    if (isLoggedIn) mutation.mutate();
  };

  if (!isDisplay || isLoading) return null;

  return (
    <div className="pt-[30px] px-6 pb-1">
      <div className="bg-gray2 rounded-[14px] flex border border-gray15 overflow-hidden p-4 gap-3 items-center justify-between">
        <div>
          <p className={`${TYPO.TYPO7_1_RG} text-gray60`}>{subTitle}</p>
          <p className={`${TYPO.TYPO5_1_MD} text-gray80 `}>{title}</p>
        </div>
        <Button
          type="primary"
          btnClass="w-fit"
          disabled={isRequesting}
          clickHandler={() => {
            if (isRequesting) return;
            clickHandler && clickHandler();
            requestData();
          }}
          text={buttonText}
          size="md"
          dataGtmId={dataGtmId}
        />
      </div>

      <CustomToast
        message={
          toastStatus === "success"
            ? "요청이 완료되었어요"
            : "이미 요청한 종목이에요"
        }
        isVisible={toastStatus}
        onClose={() => setToastStatus(null)}
        isSuccess={toastStatus === "success"}
        width={200}
        successIconFill={"#34BB7A"}
      />
    </div>
  );
}
export default RequestDataTemp;
